export function getRandomHexColor() {
  const randomColorComponent = () => Math.floor(Math.random() * 256);

  const color = `#${randomColorComponent().toString(16).padStart(2, '0')}${randomColorComponent().toString(16).padStart(2, '0')}${randomColorComponent().toString(16).padStart(2, '0')}`;

  return color;
}
